var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("span", { staticClass: "products-price__price" }, [
      _vm._v(_vm._s(_vm.item.price)),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "products-price__sale-price" }, [
      _vm._v(_vm._s(_vm.item.salePrice)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }